module.exports = __webpack_public_path__ + "static/si_colaps-b1e9fc98c15ce5af1a6a8d6c9d5b0e97.jpg";